
import Vue from "vue";

export default Vue.extend({
	props: {
		ico: String,
		icoSize: {
			type: String,
			default: "1x"
		},
		icoLib: {
			type: String,
			default: "far"
		},
		text: String,
		border: Boolean,
		warning: Boolean,
		danger: Boolean
	}
});